import React from 'react';

const HeroSection = () => {
  return (
    <div className="bg-white py-6 md:py-8 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">Product Search</h1>
          <p className="text-sm md:text-base text-gray-700 mb-1">
            Quickly and conveniently find any product in your store fast!
          </p>
          <p className="text-sm md:text-base text-gray-700">
            <strong>Quick How-To:</strong> Simply start typing below to search for any product and press "Enter" on your keyboard
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;